import React, { useState, useRef,useEffect } from 'react';
import Root_menu from './Root_menu';
import MenuIcon from '@mui/icons-material/Menu';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Drawer from '@mui/material/Drawer';
import Cart_Preview from './View_CartPreview';
import View_Favorites from './View_Favorites';
import View_Search from './View_Search';
import View_SearchAutocom from './View_SearchAutocom';
import View_Account from './View_Account';
import CancelIcon from '@mui/icons-material/Cancel';
import { ArrowDownward, SnippetFolder } from '@mui/icons-material';
import Snippet_DrawerTitle from './Snippet_DrawerTitle';
import { Link } from 'react-router-dom';
import View_Login from './View_Login';

import { Avatar } from '@mui/material';


function Root_Header({ cart, removeFromCart, addToCart, increaseQuantity, decreaseQuantity, favorites, removeFromFavorites, recent, removeFromRecent}) {

  const [openDrawer, setOpenDrawer] = useState(null); // Use null to represent no drawer open
  const [authen, setAuthen] = useState('anonymous'); // Use null to represent no drawer open
  const containerRef = useRef(null);

  const toggleDrawer = (drawer) => () => {
    setOpenDrawer(openDrawer === drawer ? null : drawer);
  };
  const handleDrawerClose = () => {
    setOpenDrawer(null);
  };
  const handleContentClick = (event) => {
    event.stopPropagation(); // Prevent click event from propagating to the parent
  };
  const [activeName, setActiveName] = useState('John');
  const [activeAvatar, setActiveAvatar] = useState('avatar1');
  useEffect(() => {
    const userIcon = document.getElementById('usericon');
    if (userIcon) {
      userIcon.classList.add('blinkme');
      setTimeout(() => {
        userIcon.classList.remove('blinkme');
      }, 1100);
    }
  }, [activeAvatar]);

  return (
    <header className='bg-white'>
      <div className='w-100 flex-center justify-content-between'>
        <div className='flex-center align-items-center'>
          <a className='h-btn h-btn-lg text-white d-none' href='/'><MenuIcon/></a>
          <a className='logo m-auto ms-3 ' href='/'></a>
        </div>
        <Root_menu/>
        <div>                  
            <Link onClick={toggleDrawer('search')} className='h-btn' ><SearchOutlinedIcon/></Link>            
            <Link id="favorite" className='h-btn' onClick={toggleDrawer('favorites')}>            
              <span className='outlined' ><FavoriteBorderOutlinedIcon/></span>
              <span className='filled d-none'><FavoriteIcon/></span>
              <div class="ripple"></div>
            </Link>
            {authen==='anonymous'&& <Link className='h-btn'  onClick={toggleDrawer('account')}><PersonOutlineOutlinedIcon/></Link> }
            {authen==='logged-kids'&& <Link className='h-btn'  onClick={toggleDrawer('account')}>
              <Avatar sx={{ width: 32, height: 32 }} className='bg-success text-text'>K</Avatar>
            </Link> }     
            {authen==='logged'&& <Link id="usericon" className='h-btn h-btn-img'  onClick={toggleDrawer('account')}>
              <img className='rounded-circle' src={`/img/${activeAvatar}.jpg`}  style={{zIndex:'4999', width: '40px', height: '40px'}}/>
              <span class="ripple"></span>
            </Link> }               
          <Link id="cart" className='h-btn h-btn-lg bg-theme-secondary-dark text-white' onClick={toggleDrawer('cart')}>
            <ShoppingCartOutlinedIcon/>{cart.length !== 0 && <>{cart.length}</>}
            <div class="ripple"></div>
            </Link>
        </div>        
      </div>  

      <Drawer anchor="right" open={openDrawer === 'search'} onClose={handleDrawerClose}  transitionDuration={{ enter: 600, exit: 300 }}>
          <Snippet_DrawerTitle title={'Search'} toggleDrawer={toggleDrawer}>
            <div className='p-2'><View_SearchAutocom /></div>
          </Snippet_DrawerTitle>         
      </Drawer>
      
      <Drawer anchor="right" open={openDrawer === 'favorites'} onClose={handleDrawerClose}  transitionDuration={{ enter: 1000, exit: 1000 }}>
          <Snippet_DrawerTitle title={'Favorites'} toggleDrawer={toggleDrawer}>
            <div className='px-1'><View_Favorites favorites={favorites} removeFromFavorites={removeFromFavorites}/> </div> 
          </Snippet_DrawerTitle>           
      </Drawer>
      <Drawer anchor="right" open={openDrawer === 'account'} onClose={handleDrawerClose}   transitionDuration={{ enter: 600, exit: 300 }}>
        <div style={{minWidth:'300px'}}>
          <Snippet_DrawerTitle title={'Account'} toggleDrawer={toggleDrawer}>
          {authen==='anonymous'&& <div className='p-2'><View_Login setAuthen={setAuthen}/></div>}
          {authen==='logged'&& <View_Account setAuthen={setAuthen}  activeName={activeName} setActiveName={setActiveName} activeAvatar={activeAvatar} setActiveAvatar={setActiveAvatar} />}
          </Snippet_DrawerTitle>  
        </div>
      </Drawer>


      <Drawer anchor="right" open={openDrawer === 'cart'} onClose={handleDrawerClose} transitionDuration={{ enter: 600, exit: 300 }}>
        <div
          role="presentation"
          onClick={handleDrawerClose}
          onKeyDown={handleDrawerClose}
          ref={containerRef}
          className='h-100'
        >
          <div onClick={handleContentClick} className='d-flex flex-column justify-content-between h-100'>
            <div>
            <Snippet_DrawerTitle title={'View Cart'} toggleDrawer={toggleDrawer}>
              <div className='p-2'><Cart_Preview cart={cart} removeFromCart={removeFromCart} increaseQuantity={increaseQuantity} decreaseQuantity={decreaseQuantity} buttontype={'cart'}/></div>
            </Snippet_DrawerTitle>    
            </div>        
            { recent.length > 0 && (            
              <div>
            <Snippet_DrawerTitle title={'Recently Removed'} toggleDrawer={toggleDrawer} HideCancelBtn={'hide'}>
                <Cart_Preview cart={recent} addToCart={addToCart} removeFromCart={removeFromCart} removeFromRecent={removeFromRecent} buttontype={'recent'}/>            
            </Snippet_DrawerTitle>            
              </div>
            )
            }
          </div>
        </div>
      </Drawer>
    </header>
  );
};

export default Root_Header;